export default __webpack_public_path__ + "e179223d6b256efbecf96356cc98bed5.png";